import axios from 'axios';

const getBasicAuthHeader = () => {
  const username = process.env.REACT_APP_API_USERNAME;
  const password = process.env.REACT_APP_API_PASSWORD;
  return `Basic ${btoa(`${username}:${password}`)}`;
};

const authHeaders = () => ({
  'Content-Type': 'application/json',
  Accept: '*/*',
  Authorization: getBasicAuthHeader(),
});

/**
 * Fetch cached or freshly computed course analysis from the instructor API.
 */
export async function fetchCourseAnalysis(courseId) {
  const apiUrl = process.env.REACT_APP_API_URL;
  const res = await axios.get(`${apiUrl}/api/course/${courseId}/analysis`, {
    headers: authHeaders(),
  });
  return res.data;
}

/**
 * Recompute course analysis (same response shape as GET).
 */
export async function regenerateCourseAnalysis(courseId) {
  const apiUrl = process.env.REACT_APP_API_URL;
  const res = await axios.post(`${apiUrl}/api/course/${courseId}/analysis/regenerate`, {}, {
    headers: authHeaders(),
  });
  return res.data;
}
